import { Modal } from 'antd';
import './custom-modal.scss';

const CustomModal = (props) => {
    return <Modal {...props}>{props.children}</Modal>;
};

export default CustomModal;
